import { StateCreator } from 'zustand';

type State = {
  nodeErrors: Record<string, string[]>;
};

type Actions = {
  setNodeErrors: (errorsMap: Record<string, string[]>) => void;
  setNodeErrorsByNodeId: (nodeId: string, errors: string[]) => void;
  removeNodeErrorByNodeId: (nodeId: string, errorMsg: string) => void;
  clearNodeErrors: () => void;
};

export type ErrorsSlice = State & Actions;

export const createErrorsSlice: StateCreator<ErrorsSlice, [['zustand/immer', never]], [], ErrorsSlice> = (set) => ({
  nodeErrors: {},
  setNodeErrors: (errorsMap) => set(() => ({ nodeErrors: errorsMap })),
  setNodeErrorsByNodeId: (nodeId, errors) =>
    set((state) => ({
      errors: {
        ...state.nodeErrors,
        [nodeId]: errors,
      },
    })),
  removeNodeErrorByNodeId: (nodeId, errorMsg) =>
    set((state) => {
      const errors = state.nodeErrors[nodeId]?.filter((err) => err !== errorMsg);
      const updated = { ...state.nodeErrors };
      if (!errors?.length) {
        delete updated[nodeId];
      } else {
        updated[nodeId] = errors;
      }
      return { errors: updated };
    }),
  clearNodeErrors: () => set(() => ({ nodeErrors: {} })),
});
